import { getCart } from '@/js/api/cart.ts';
import CartPage from '@/js/vue/cart/cart-page.vue';
import { useCartTotal } from '@/js/vue/composable/cart-total.ts';
import { createApp } from 'vue';

const CART_SELECTOR = '.vue-cart';
const cartElement = document.querySelector<HTMLElement>(CART_SELECTOR);
export const SPINNER_CLASS = 'spinner';

export async function initCart() {
  if (!cartElement)
    return;
  const { data: cart } = await getCart();

  const app = createApp(CartPage, {
    cart,
    checkoutUrl: cartElement.dataset.checkoutUrl ?? null,
  });
  app.mount(cartElement);
  cartElement.classList.remove(SPINNER_CLASS);
}

export async function initCartTotal() {
  const { setCartTotal } = useCartTotal();
  const { data } = await getCart();
  if (data) {
    setCartTotal(data);
  }
}
